import { Injectable } from '@angular/core';
//import domtoimage from 'dom-to-image';
import html2canvas from 'html2canvas';

@Injectable()
export class PrintProvider{
  constructor() {}

    /*print(componentName) {
      var node = document.getElementById(componentName);

      domtoimage.toPng(node)
      .then(function (dataUrl) {
        alert("Got Data!");  

        //var popup=window.open();
          //  popup.document.write('<img src=' + dataUrl + '>');
          //  popup.document.close();
          //  popup.focus();
          //  popup.print();
          //  popup.close();
      })
      .catch(function (error) {
          console.error('oops, something went wrong!', error);
      });
    }*/

    printCanvas(componentName,callback) {
      var node = document.getElementById(componentName);

      html2canvas(node,{
        useCORS: true
    }).then(function (canvas) {
      //alert("Got Data!");  
      //var dataUrl= canvas.toDataURL("image/png");
      var dataUrl= canvas.toDataURL("image/jpg");

      callback(dataUrl);

      //TODO do something with image - probably take a callback 

      //var popup=window.open();
        //  popup.document.write('<img src=' + dataUrl + '>');
        //  popup.document.close();
        //  popup.focus();
        //  popup.print();
        //  popup.close();
    })
    .catch(function (error) {
        console.error('oops, something went wrong!', error);
        callback("Error");
    });

    }
}


// WEBPACK FOOTER //
// ./src/providers/print/print.ts